/**
 * fetchData Utility — Bifrost
 * 
 * Uses getAuthToken() (synchronous) from authHelper.
 * On localhost: getAuthToken() returns the hardcoded DEV_TOKEN (CRM-Zolo pattern)
 * On deployed: getAuthToken() returns the cached Bifrost token
 * 
 * On 401/403 in deployed envs: redirects to Bifrost login
 * On 401/403 on localhost: does NOT redirect (just returns response)
 */
import { getAuthToken, redirectToLogin } from './authHelper';

const url = require('url');
const server_address = process.env.REACT_APP_SERVER_ADDRESS;

export const fetchData = (endpoint, method = 'get', body = {}, query = {}, optionalHeaders = {}, isMultipart = false) => {
    method = method.toUpperCase();

    let queryString = '';

    if (Object.keys(query).length > 0) {
        queryString = url.format({ query });
    }

    const targetURL = server_address + endpoint + queryString;
    let config;

    // getAuthToken() returns DEV_TOKEN on localhost, Bifrost token on deployed
    const token = getAuthToken();

    if (isMultipart === false) {
        config = { method, headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` } };
    } else {
        config = { method, headers: { "Authorization": `Bearer ${token}` } };
    }

    if (Object.keys(optionalHeaders).length > 0) {
        let additionalHeaders = Object.assign({}, optionalHeaders);
        config.headers = { ...config.headers, ...additionalHeaders };
    }

    if ((method === 'POST' || method === 'PUT' || method === 'PATCH') && isMultipart === false) {
        config.body = JSON.stringify(body);
    } else if ((method === 'POST' || method === 'PUT' || method === 'PATCH') && isMultipart === true) {
        config.body = body;
    }

    return fetch(targetURL, config)
        .then((response) => {
            if (response.status === 401 || response.status === 403) {
                const hostname = window.location.hostname;
                if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
                    redirectToLogin();
                    return;
                }
            }
            return response;
        })
        .then(response => {
            if (!response) return;
            return response.json().then(data => ({ status: response.status, data }));
        });
};


// WEBPACK FOOTER //
// ./src/utils/fetchData.js